var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 38,
    fill: "#73151F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6468 29.8727C31.9505 29.736 29.736 31.9505 29.8727 34.6468C29.9893 36.955 31.8651 38.8309 34.1742 38.9483C36.8705 39.0851 39.0851 36.8705 38.9483 34.1742C38.8309 31.8661 36.955 29.9902 34.6468 29.8736V29.8727Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5135 41.9985H30.3079V66.9668H38.5135V41.9985Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.012 41.4106C54.8549 41.4106 52.6367 42.9166 51.0857 44.8402V41.9989H42.8801V66.9671H51.0857V52.3364C51.3078 49.1931 53.5517 48.3726 55.144 48.3726C56.8207 48.3726 58.938 49.1885 58.938 53.7763V66.9662H67.1436V49.3794C67.1436 49.3794 66.7755 41.4097 58.012 41.4097V41.4106Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn1);
export default __webpack_public_path__ + "static/media/linkedIn1.15159cd3e2faeb7b3ac48e6f9348242e.svg";
export { ForwardRef as ReactComponent };